export default function ({ store, route, redirect, error }) {
  if (store.state.auth.user.userTypeId!==2) {
    error({
      statusCode: 401,
      message: 'test'
    })
  }
}